import { DevBoxAddOns, DevBoxHyperVAddOn, DeviceConfiguration } from '../../../models/add-ons';
import { UnionValueMap } from '../../../types/union-map';
import {
    ActionName,
    ActionType,
    ErrorPayload,
    FailedPayload,
    IndexedPayload,
    OptionalResultPayload,
    ResultPayload,
} from '../core-actions';
import { listDevBoxAddOns, loadDevBoxAddOnsForDevBoxes } from './add-ons-action-creators';

type DevBoxAddOnsActionName =
    | ActionName<'ListDevBoxAddOns', 'Error' | 'Failed' | 'Success'>
    | ActionName<'LoadDevBoxAddOnsForDevBoxes', 'Error' | 'Failed' | 'Success'>;

export type DevBoxAddOnsActionType =
    | ActionType<'ADD_DEV_BOX_HYPER_V', '_ACCEPTED' | '_ERROR' | '_FAILED' | '_SUCCESS'>
    | ActionType<'POLL_NON_TERMINAL_DEV_BOX_HYPER_V', '_COMPLETE' | '_ERROR'>
    | ActionType<'LIST_DEV_BOX_ADD_ONS', '_ERROR' | '_FAILED' | '_SUCCESS'>
    | ActionType<'LOAD_DEV_BOX_ADD_ONS_FOR_DEV_BOXES', '_ERROR' | '_FAILED' | '_SUCCESS'>;

export const DevBoxAddOnsActionType: UnionValueMap<DevBoxAddOnsActionName, DevBoxAddOnsActionType> = {
    ListDevBoxAddOnsError: 'LIST_DEV_BOX_ADD_ONS_ERROR',
    ListDevBoxAddOnsFailed: 'LIST_DEV_BOX_ADD_ONS_FAILED',
    ListDevBoxAddOnsSuccess: 'LIST_DEV_BOX_ADD_ONS_SUCCESS',
    ListDevBoxAddOns: 'LIST_DEV_BOX_ADD_ONS',
    LoadDevBoxAddOnsForDevBoxes: 'LOAD_DEV_BOX_ADD_ONS_FOR_DEV_BOXES',
    LoadDevBoxAddOnsForDevBoxesError: 'LOAD_DEV_BOX_ADD_ONS_FOR_DEV_BOXES_ERROR',
    LoadDevBoxAddOnsForDevBoxesFailed: 'LOAD_DEV_BOX_ADD_ONS_FOR_DEV_BOXES_FAILED',
    LoadDevBoxAddOnsForDevBoxesSuccess: 'LOAD_DEV_BOX_ADD_ONS_FOR_DEV_BOXES_SUCCESS',
};

/**
 * Payloads
 */

export interface AddDevBoxHyperVPayload extends IndexedPayload {
    name: string;
    deviceConfiguration: DeviceConfiguration;
}

export type PollNonTerminalDevBoxHyperVCompletePayload = IndexedPayload & OptionalResultPayload<DevBoxHyperVAddOn>;
export type AddDevBoxHyperVAcceptedPayload = IndexedPayload & ResultPayload<DevBoxHyperVAddOn>;
export type AddDevBoxHyperVErrorPayload = ErrorPayload & IndexedPayload;
export type AddDevBoxHyperVFailedPayload = FailedPayload & IndexedPayload;
export type AddDevBoxHyperVSuccessPayload = IndexedPayload & ResultPayload<DevBoxHyperVAddOn>;

export type ListAddOnsSuccessPayload = IndexedPayload & ResultPayload<DevBoxAddOns[]>;

/**
 * Action shorthands
 */

export type ListDevBoxAddOnsAction = ReturnType<typeof listDevBoxAddOns>;
export type LoadDevBoxAddOnsForDevBoxesAction = ReturnType<typeof loadDevBoxAddOnsForDevBoxes>;
